import { DashboardSpecMigrator } from '../dashboard-schema-migrator';
import { V0Migrator } from './v0Migrator';
import { V1Migrator } from './v1Migrator';

// We use any for the generic entries in `DashboardSpecMigrator` to avoid typing issues between
// the more specific generic settings in the individual migrators and the `Record` here that is just
// trying to enforce that we have some sort of `DashboardSpecMigrator` NOT that we have one that uses
// specific generic values.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const migrators: Record<string, DashboardSpecMigrator<any, any>> = {
  '0': V0Migrator,
  '1': V1Migrator,
};
